<template>
  <div
    v-if="alertCodes.length"
    class="architecture-preview-alerts d-flex flex-column ga-4"
  >
    <JobProfilePreviewArchitectureAlertItem
      v-for="code in alertCodes"
      :key="code"
      :code="code"
      :tooltip-context="tooltipContext"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';
import { useJobArchitecture } from '@/stores/jobArchitecture/jobArchitecture';
import {
  computeArchitectureAlerts,
  getProfileAlertTooltipContext,
  sortArchitectureAlertCodes,
} from '@/components/jobArchitecture/alertHelpers';
import JobProfilePreviewArchitectureAlertItem from './JobProfilePreviewArchitectureAlertItem.vue';

const props = defineProps({
  profileUlid: {
    type: String,
    required: true,
  },
});

const { treeData } = storeToRefs(useJobArchitecture());
const { isStandaloneJobNav } = storeToRefs(useAppAuthData());

const alertsData = computed(() => computeArchitectureAlerts(treeData.value, {
  skipEmployeeAlerts: isStandaloneJobNav.value,
}));

const alertCodes = computed(() => sortArchitectureAlertCodes(
  alertsData.value.byProfile.get(props.profileUlid) ?? [],
));

const tooltipContext = computed(() => getProfileAlertTooltipContext(
  alertsData.value.profileCounts,
  props.profileUlid,
));
</script>
